module.exports = __webpack_public_path__ + "static/media/tip3.65661c0e.svg";